import React from "react";
import {Badge} from "peggirkit";
import {FormattedMessage} from "react-intl";
import BadgeDotIndicator from "peggirkit/dist/components/Badge/BadgeElements/Indicator/BadgeDotIndicator";
import {CartKind} from "@widgets/reports/cartTimeline/CartTimelineUtils";

type BadgeColor = "primary" | "warning" | "success" | "secondary" | "danger";

const kindColors: Record<CartKind, BadgeColor> = {
    active: "primary",
    paying: "warning",
    ordered: "success",
    pos: "secondary",
    expired: "danger",
    reset: "danger",
};

type Props = {
    kind: CartKind,
};

const CartKindBadge = ({kind}: Props) => (
    <Badge
        containerClassname={"inline-flex"}
        color={kindColors[kind]}
        size={"xs"}
        indicator={kind === "active" || kind === "paying" ? <BadgeDotIndicator/> : undefined}
    >
        <FormattedMessage id={`cartTimeline.kind.${kind}`}/>
    </Badge>
);

export default CartKindBadge;